import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import {
  Modal,
  Button,
  ToastContainer,
  Toast,
  Icon
} from '@salesforce/design-system-react';

import './UpdateDataExtensionModal.scss';

export class UpdateDataExtensionModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showError: false,
      showSuccess: false
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.dataExtension !== prevProps.dataExtension) {
      if (
        this.props.dataExtension.saveSuccess &&
        !this.props.dataExtension.error
      ) {
        this.setState({ showSuccess: true });
      }
      if (this.props.dataExtension.error) {
        if (
          !this.props.dataExtension.saveSuccess &&
          !this.props.dataExtension.error.response.ok
        ) {
          this.setState({ showError: true });
        }
      }
    }
  }

  handleClose() {
    this.props.actions.closeModal('updateDataExtension');
  }

  handleUpdateDataExtension() {
    this.props.actions.submitUpdateDataExtension(
      {},
      this.props.dataExtension.dataFilter
    );
    this.props.actions.closeModal('updateDataExtension');
  }

  render() {
    const { formatMessage } = this.props.intl;
    const isOpen = this.props.modals.updateDataExtension
      ? this.props.modals.updateDataExtension.isOpen
      : false;
    const newDERange =
      this.props.dataExtension.dataFilter.rangeStart ||
      this.props.dataExtension.dataFilter.rangeEnd;
    const currentDERange =
      this.props.dataExtension.data.rangeStart ||
      this.props.dataExtension.data.rangeEnd;
    return (
      <div>
        <ToastContainer>
          {this.state.showSuccess ? (
            <Toast
              labels={{
                heading: formatMessage({
                  id: 'UpdateDataExtensionModal.toasts.success.heading'
                }),
                details: formatMessage({
                  id: 'UpdateDataExtensionModal.toasts.success.details'
                })
              }}
              onRequestClose={() => {
                this.setState({ showSuccess: false });
              }}
              variant="success"
              duration={8000}
            />
          ) : null}
          {this.state.showError ? (
            <Toast
              labels={{
                heading: formatMessage({
                  id: 'UpdateDataExtensionModal.toasts.error.heading'
                })
              }}
              onRequestClose={() => {
                this.setState({ showError: false });
              }}
              variant="error"
            />
          ) : null}
        </ToastContainer>
        <Modal
          containerClassName="update-data-extension-modal"
          isOpen={isOpen}
          onRequestClose={() => this.handleClose()}
          title={formatMessage({
            id: 'UpdateDataExtensionModal.title'
          })}
          footer={[
            <Button
              label={formatMessage({
                id: 'UpdateDataExtensionModal.footer.cancel'
              })}
              onClick={() => this.handleClose()}
              key="updateDataExtensionCancelBtn"
            />,
            <Button
              label={formatMessage({
                id: 'UpdateDataExtensionModal.footer.update'
              })}
              variant="brand"
              onClick={() => this.handleUpdateDataExtension()}
              key="updateDataExtensionCreateBtn"
            />
          ]}
        >
          <div className="slds-grid slds-gutters update-data-extension-modal-body">
            <div className="slds-grid slds-col slds-size_1-of-2 update-de-modal-description">
              <div className="slds-col">
                <div className="info-bar">
                  <p>
                    <Icon
                      className="info-icon"
                      category="utility"
                      name="info"
                      size="xx-small"
                    />
                    <FormattedMessage id="UpdateDataExtensionModal.body.info" />
                  </p>
                </div>
                <p>
                  <FormattedMessage id="UpdateDataExtensionModal.body.description" />
                </p>
                <ol className="slds-list_ordered">
                  <li>
                    <p>
                      <FormattedMessage
                        id="UpdateDataExtensionModal.body.ol.1.p1"
                        values={{
                          subscriberType: (
                            <strong>
                              {formatMessage({
                                id:
                                  'UpdateDataExtensionModal.body.ol.1.subscriberType'
                              })}
                            </strong>
                          )
                        }}
                      />
                    </p>
                    <p>
                      <FormattedMessage id="UpdateDataExtensionModal.body.ol.1.p2" />
                    </p>
                  </li>
                  <li>
                    <p>
                      <FormattedMessage
                        id="UpdateDataExtensionModal.body.ol.2.p1"
                        values={{
                          subscriberType: (
                            <strong>
                              {formatMessage({
                                id:
                                  'UpdateDataExtensionModal.body.ol.2.subscriberType'
                              })}
                            </strong>
                          )
                        }}
                      />
                    </p>
                    <p>
                      <FormattedMessage id="UpdateDataExtensionModal.body.ol.2.p2" />
                    </p>
                  </li>
                </ol>
              </div>
            </div>
            <div className="slds-grid slds-col slds-size_1-of-2 update-de-modal-summary">
              <div className="slds-col slds-size_1-of-2">
                <h2>
                  <FormattedMessage id="UpdateDataExtensionModal.body.newDataExtension.description" />
                </h2>
                <div className="data-extension-summary">
                  <div className="de-config">
                    <h3>
                      <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.lookback.title" />
                    </h3>
                    <h4>
                      <FormattedMessage
                        id="UpdateDataExtensionModal.body.previousDataExtension.lookback.setting"
                        values={{
                          days: this.props.dataExtension.dataFilter.lookback
                        }}
                      />
                    </h4>
                  </div>
                  <div className="de-config">
                    <h3>
                      <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.emailType.title" />
                    </h3>
                    <h4>
                      <FormattedMessage
                        id={`UpdateDataExtensionModal.body.previousDataExtension.emailType.${
                          this.props.dataExtension.dataFilter.emailType
                        }`}
                      />
                    </h4>
                  </div>
                  {newDERange ? (
                    <div className="de-config">
                      <h3>
                        <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.rangeStart" />
                      </h3>
                      <h4>{this.props.dataExtension.dataFilter.rangeStart}</h4>
                    </div>
                  ) : null}
                  {newDERange ? (
                    <div className="de-config">
                      <h3>
                        <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.rangeEnd" />
                      </h3>
                      <h4>{this.props.dataExtension.dataFilter.rangeEnd}</h4>
                    </div>
                  ) : null}
                  <div className="de-config">
                    <h3>
                      <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.undersaturated" />
                    </h3>
                    <h4>
                      {this.props.dataExtension.dataFilter.undersaturated}
                    </h4>
                  </div>
                  <div className="de-config">
                    <h3>
                      <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.oversaturated" />
                    </h3>
                    <h4>{this.props.dataExtension.dataFilter.oversaturated}</h4>
                  </div>
                </div>
              </div>
              <div className="slds-col slds-size_1-of-2">
                <h2>
                  <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.description" />
                </h2>
                <div className="data-extension-summary">
                  <div className="de-config">
                    <h3>
                      <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.lookback.title" />
                    </h3>
                    <h4>
                      <FormattedMessage
                        id="UpdateDataExtensionModal.body.previousDataExtension.lookback.setting"
                        values={{
                          days: this.props.dataExtension.data.lookback
                        }}
                      />
                    </h4>
                  </div>
                  <div className="de-config">
                    <h3>
                      <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.emailType.title" />
                    </h3>
                    <h4>
                      <FormattedMessage
                        id={`UpdateDataExtensionModal.body.previousDataExtension.emailType.${
                          this.props.dataExtension.data.emailType
                        }`}
                      />
                    </h4>
                  </div>
                  {currentDERange ? (
                    <div className="de-config">
                      <h3>
                        <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.rangeStart" />
                      </h3>
                      <h4>{this.props.dataExtension.data.rangeStart}</h4>
                    </div>
                  ) : null}
                  {currentDERange ? (
                    <div className="de-config">
                      <h3>
                        <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.rangeEnd" />
                      </h3>
                      <h4>{this.props.dataExtension.data.rangeEnd}</h4>
                    </div>
                  ) : null}
                  <div className="de-config">
                    <h3>
                      <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.undersaturated" />
                    </h3>
                    <h4>{this.props.dataExtension.data.undersaturated}</h4>
                  </div>
                  <div className="de-config">
                    <h3>
                      <FormattedMessage id="UpdateDataExtensionModal.body.previousDataExtension.oversaturated" />
                    </h3>
                    <h4>{this.props.dataExtension.data.oversaturated}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

UpdateDataExtensionModal.propTypes = {
  dataExtension: PropTypes.object.isRequired,
  children: PropTypes.element,
  location: PropTypes.object,
  modals: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(UpdateDataExtensionModal);
